(function () {
  'use strict';

  function money(value, currency) {
    var n = Math.round(value * 100) / 100;
    return n.toLocaleString('bg-BG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency;
  }

  function init(root) {
    if (root.dataset.sbInit) return;
    root.dataset.sbInit = '1';

    var cfgEl = root.querySelector('.sb-config');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var currency = cfg.currency || '€';
    var formsById = {};
    cfg.forms.forEach(function (f) { formsById[f.id] = f; });

    // Размерът се разпознава от името на продукта (250 гр., 1 кг., 10/16/100 бр.)
    function sizeOf(name) {
      var t = name || '';
      if (/1\s*кг/i.test(t)) return '1 кг.';
      if (/250/.test(t)) return '250 гр.';
      if (/100\s*бр/i.test(t)) return '100 бр.';
      if (/16\s*бр/i.test(t)) return '16 бр.';
      if (/10\s*бр/i.test(t)) return '10 бр.';
      return '';
    }
    cfg.varieties.forEach(function (v) { v.size = sizeOf(v.name); });

    // Размерите се извличат динамично от продуктите, които имат абонаментен план.
    // Добавиш ли план на нов размер в Shopify, той се появява тук автоматично.
    var sizesByForm = {};
    cfg.varieties.forEach(function (v) {
      if (!v.size) return;
      var arr = sizesByForm[v.form] || (sizesByForm[v.form] = []);
      if (arr.indexOf(v.size) < 0) arr.push(v.size);
    });
    function sizeRank(sz) { return /100|кг/i.test(sz) ? 2 : 1; } // малкият размер е пръв (по подразбиране)
    Object.keys(sizesByForm).forEach(function (fid) {
      sizesByForm[fid].sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
    });

    var state = {
      forms: new Set(),
      varieties: new Set(),
      packages: {},      // formId -> Set(packageId)
      quantities: {},    // varietyId -> брой на месец
      plan: null
    };

    var elPkgStep = root.querySelector('[data-step="packages"]');
    var elPkgGroups = root.querySelector('#sb-pkg-groups');
    var elVarStep = root.querySelector('[data-step="varieties"]');
    var elQtyStep = root.querySelector('[data-step="quantity"]');
    var elQtyList = root.querySelector('#sb-qty-list');
    var elPlanStep = root.querySelector('[data-step="plan"]');

    /* ---------- progressive reveal: всяка стъпка изскача след предишната ---------- */
    function setStep(el, visible) {
      if (!el) return;
      var hidden = el.classList.contains('sb-step--hidden');
      if (visible && hidden) {
        el.classList.remove('sb-step--hidden');
        el.classList.add('sb-step--in');
      } else if (!visible && !hidden) {
        el.classList.add('sb-step--hidden');
        el.classList.remove('sb-step--in');
      }
    }
    // Стъпка "опаковка" има смисъл само ако някоя избрана форма предлага повече от един размер
    function needsPackaging() {
      return Array.from(state.forms).some(function (fid) {
        return (sizesByForm[fid] || []).length > 1;
      });
    }
    // Преномерирай видимите стъпки, за да няма дупки (напр. когато опаковката се прескача)
    function renumberSteps() {
      var n = 0;
      root.querySelectorAll('.sb-step').forEach(function (st) {
        if (st.classList.contains('sb-step--hidden')) return;
        n++;
        var numEl = st.querySelector('.sb-step__num');
        if (numEl) numEl.textContent = n;
      });
    }
    function updateStepVisibility() {
      var hasSize = Object.keys(state.packages).some(function (fid) {
        return state.forms.has(fid) && state.packages[fid].size > 0;
      });
      var hasVariety = state.varieties.size > 0;
      setStep(elPkgStep, needsPackaging());
      setStep(elVarStep, hasSize);
      setStep(elQtyStep, hasVariety);
      setStep(elPlanStep, hasVariety);
      renumberSteps();
    }
    var varietyButtons = root.querySelectorAll('.sb-opt[data-group="varieties"]');
    var varHint = root.querySelector('#sb-var-hint');

    /* ---------- show varieties matching the selected form(s) ---------- */
    function varietyById(id) {
      return cfg.varieties.find(function (v) { return v.id === id; });
    }
    function sizeChosen() {
      return Object.keys(state.packages).some(function (fid) {
        return state.forms.has(fid) && state.packages[fid].size > 0;
      });
    }
    // продукт е видим само ако формата му е избрана И отговаря на избран размер
    function matchesSelection(v) {
      if (!v || !state.forms.has(v.form)) return false;
      var pkgs = state.packages[v.form];
      if (!pkgs || pkgs.size === 0) return false;
      return pkgs.has(v.size);
    }
    function filterVarieties() {
      var anyVisible = false;
      varietyButtons.forEach(function (btn) {
        var show = matchesSelection(varietyById(btn.dataset.value));
        btn.hidden = !show;
        if (!show && btn.classList.contains('is-selected')) {
          btn.classList.remove('is-selected');
          state.varieties.delete(btn.dataset.value);
        }
        if (show) anyVisible = true;
      });
      if (varHint) {
        if (state.forms.size === 0) {
          varHint.style.display = 'block';
          varHint.textContent = 'Първо изберете форма в стъпка 1.';
        } else if (!sizeChosen()) {
          varHint.style.display = 'block';
          varHint.textContent = 'Изберете размер в стъпка 2, за да видите наличните кафета.';
        } else if (!anyVisible) {
          varHint.style.display = 'block';
          varHint.textContent = 'За избрания размер няма налични кафета.';
        } else {
          varHint.style.display = 'none';
        }
      }
      renderQuantities();
    }

    /* ---------- per-product quantity ---------- */
    function selectedVarietyObjs() {
      return cfg.varieties.filter(function (v) { return state.varieties.has(v.id); });
    }
    function renderQuantities() {
      if (!elQtyList) return;
      // премахни количествата за вече неизбрани продукти
      Object.keys(state.quantities).forEach(function (id) {
        if (!state.varieties.has(id)) delete state.quantities[id];
      });
      var chosen = selectedVarietyObjs();
      elQtyList.innerHTML = '';
      if (chosen.length === 0) {
        var empty = document.createElement('p');
        empty.className = 'sb-qty-empty';
        empty.textContent = 'Изберете кафе в стъпка 3, за да зададете бройки.';
        elQtyList.appendChild(empty);
        return;
      }
      chosen.forEach(function (v) {
        if (!state.quantities[v.id]) state.quantities[v.id] = 1;
        var row = document.createElement('div');
        row.className = 'sb-qty-row';

        var name = document.createElement('span');
        name.className = 'sb-qty-row__name';
        name.textContent = v.name;

        var ctrl = document.createElement('div');
        ctrl.className = 'sb-qty-row__ctrl';
        var sel = document.createElement('select');
        sel.className = 'sb-select';
        sel.setAttribute('aria-label', 'Брой на месец за ' + v.name);
        for (var i = 1; i <= 15; i++) {
          var o = document.createElement('option');
          o.value = i;
          o.textContent = i + ' бр.';
          if (i === state.quantities[v.id]) o.selected = true;
          sel.appendChild(o);
        }
        sel.addEventListener('change', function () {
          state.quantities[v.id] = parseInt(sel.value, 10) || 1;
          render();
        });
        ctrl.appendChild(sel);
        row.appendChild(name);
        row.appendChild(ctrl);
        elQtyList.appendChild(row);
      });
    }

    /* ---------- selection toggles for steps 1, 3, 5 ---------- */
    root.querySelectorAll('.sb-opt[data-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.group;
        var value = btn.dataset.value;

        if (group === 'plan') {
          root.querySelectorAll('.sb-opt[data-group="plan"]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          state.plan = value;
        } else {
          // multi select (forms, varieties)
          var set = group === 'forms' ? state.forms : state.varieties;
          if (set.has(value)) { set.delete(value); btn.classList.remove('is-selected'); }
          else { set.add(value); btn.classList.add('is-selected'); }
          if (group === 'forms') { renderPackages(); filterVarieties(); }
          if (group === 'varieties') { renderQuantities(); }
        }
        render();
      });
    });

    /* ---------- dynamic packaging (depends on selected forms) ---------- */
    function renderPackages() {
      // drop packages whose form is no longer selected
      Object.keys(state.packages).forEach(function (fid) {
        if (!state.forms.has(fid)) delete state.packages[fid];
      });

      elPkgGroups.innerHTML = '';
      if (state.forms.size === 0) return;

      state.forms.forEach(function (fid) {
        var sizes = sizesByForm[fid] || [];

        // По подразбиране избираме първия (малкия) размер
        if (state.packages[fid] === undefined) {
          state.packages[fid] = new Set();
          if (sizes[0]) state.packages[fid].add(sizes[0]);
        }

        // Един размер → авто-избран, без излишна стъпка
        if (sizes.length <= 1) return;

        var form = formsById[fid];
        var group = document.createElement('div');
        group.className = 'sb-pkg-group';

        var label = document.createElement('div');
        label.className = 'sb-pkg-group__label';
        label.innerHTML = (form ? form.name : '') + ' <small>· изберете размер</small>';
        group.appendChild(label);

        var grid = document.createElement('div');
        grid.className = 'sb-grid sb-grid--auto';

        sizes.forEach(function (sz) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sb-opt';
          if (state.packages[fid].has(sz)) b.classList.add('is-selected');
          b.innerHTML = '<span class="sb-opt__name">' + sz + '</span>';
          b.addEventListener('click', function () {
            var set = state.packages[fid];
            if (set.has(sz)) { set.delete(sz); b.classList.remove('is-selected'); }
            else { set.add(sz); b.classList.add('is-selected'); }
            filterVarieties();
            render();
          });
          grid.appendChild(b);
        });

        group.appendChild(grid);
        elPkgGroups.appendChild(group);
      });
    }

    /* ---------- pricing (prototype model) ---------- */
    function planObj() {
      return cfg.plans.find(function (p) { return p.id === state.plan; }) || null;
    }
    function totalPieces() {
      return selectedVarietyObjs().reduce(function (s, v) { return s + (state.quantities[v.id] || 1); }, 0);
    }
    function compute() {
      var monthly = selectedVarietyObjs().reduce(function (s, v) {
        return s + (parseFloat(v.price) || 0) * (state.quantities[v.id] || 1);
      }, 0);
      var plan = planObj();
      var discount = plan ? (parseFloat(plan.discount) || 0) : 0;
      var discounted = monthly * (1 - discount / 100);
      return { monthly: monthly, discounted: discounted, discount: discount };
    }

    /* ---------- summary + validation ---------- */
    var cta = root.querySelector('#sb-cta');
    var confirmEl = root.querySelector('#sb-confirm');
    var sumEls = {
      form: root.querySelector('[data-sum="form"]'),
      size: root.querySelector('[data-sum="size"]'),
      coffee: root.querySelector('[data-sum="coffee"]'),
      quantity: root.querySelector('[data-sum="quantity"]'),
      plan: root.querySelector('[data-sum="plan"]'),
      monthly: root.querySelector('[data-sum="monthly"]'),
      term: root.querySelector('[data-sum="term"]'),
      total: root.querySelector('[data-sum="total"]'),
      save: root.querySelector('[data-sum="save"]')
    };
    function names(set, list) {
      return list.filter(function (x) { return set.has(x.id); }).map(function (x) { return x.name; });
    }
    function setText(el, v) { if (el) el.textContent = v; }
    function markDone(step, done) {
      var el = root.querySelector('[data-step="' + step + '"]');
      if (el) el.classList.toggle('sb-step--done', done);
    }

    function render() {
      updateStepVisibility();

      var formNames = names(state.forms, cfg.forms);
      var chosen = selectedVarietyObjs();
      var coffeeStr = chosen.map(function (v) { return v.name + ' ×' + (state.quantities[v.id] || 1); }).join(', ');
      var pkgNames = [];
      Object.keys(state.packages).forEach(function (fid) {
        state.packages[fid].forEach(function (sz) { pkgNames.push(sz); });
      });
      var plan = planObj();
      var hasVariety = state.varieties.size > 0;
      var hasSize = Object.keys(state.packages).some(function (fid) {
        return state.forms.has(fid) && state.packages[fid].size > 0;
      });

      setText(sumEls.form, formNames.length ? formNames.join(', ') : '—');
      setText(sumEls.size, pkgNames.length ? pkgNames.join(', ') : '—');
      setText(sumEls.coffee, coffeeStr || '—');
      setText(sumEls.quantity, hasVariety ? (totalPieces() + ' бр.') : '—');
      setText(sumEls.plan, plan ? (plan.name + ' (−' + plan.discount + '%)') : '—');

      var c = compute();
      var ready = state.forms.size > 0 && hasVariety && hasSize && !!plan;

      // Клиентът плаща цялата сума за целия срок наведнъж, затова крайната
      // цена е месечната (с отстъпка) × броя месеци на плана
      var months = plan ? (parseInt(plan.months, 10) || 0) : 0;
      var termTotal = c.discounted * months;
      var savedTerm = (c.monthly - c.discounted) * months;

      setText(sumEls.monthly, hasVariety ? money(c.discounted, currency) : money(0, currency));
      setText(sumEls.term, months ? (months + ' месеца') : '—');
      setText(sumEls.total, (hasVariety && months) ? money(termTotal, currency) : money(0, currency));
      if (sumEls.save) {
        if (ready && savedTerm > 0) {
          sumEls.save.hidden = false;
          sumEls.save.textContent = 'Спестявате ' + money(savedTerm, currency) + ' за целия срок';
        } else {
          sumEls.save.hidden = true;
        }
      }

      markDone('forms', state.forms.size > 0);
      markDone('packages', hasSize);
      markDone('varieties', hasVariety);
      markDone('quantity', hasVariety);
      markDone('plan', !!plan);

      cta.disabled = !ready;
      cta.hidden = !ready;
      if (confirmEl) confirmEl.hidden = !ready;
      cta.dataset.payload = ready ? JSON.stringify({
        forms: Array.from(state.forms),
        varieties: Array.from(state.varieties),
        packages: Object.keys(state.packages).reduce(function (o, k) { o[k] = Array.from(state.packages[k]); return o; }, {}),
        quantities: state.quantities,
        plan: state.plan,
        months: months,
        monthly: Math.round(c.discounted * 100) / 100,
        total: Math.round(termTotal * 100) / 100
      }) : '';
    }

    /* ---------- add to cart (prototype: shows the built plan) ---------- */
    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      var plan = planObj();
      if (!plan) return;
      var months = String(plan.months);
      var box = root.querySelector('#sb-confirm');

      var items = [];
      var missing = false;
      selectedVarietyObjs().forEach(function (v) {
        var sp = v.plans && v.plans[months];
        if (!v.variant || !sp) { missing = true; return; }
        items.push({ id: v.variant, quantity: state.quantities[v.id] || 1, selling_plan: sp });
      });

      if (missing || !items.length) {
        if (box) { box.hidden = false; box.textContent = 'Някой от избраните продукти не е наличен за абонамент.'; }
        return;
      }

      var label = cta.textContent;
      cta.disabled = true;
      cta.textContent = 'Добавяне…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {
        cta.disabled = false;
        cta.textContent = label;
        if (box) { box.hidden = false; box.textContent = 'Възникна грешка при добавяне. Опитайте отново.'; }
      });
    });

    // Акцент: последната дума от заглавието на обобщението става червена
    (function () {
      var titleEl = root.querySelector('.sb-summary__head h3');
      if (!titleEl) return;
      var words = titleEl.textContent.trim().split(/\s+/);
      if (words.length < 2) return;
      var last = words.pop();
      titleEl.textContent = words.join(' ') + ' ';
      var span = document.createElement('span');
      span.className = 'sb-accent';
      span.textContent = last;
      titleEl.appendChild(span);
    })();

    // План по подразбиране — 6 месеца (препоръчан); клиентът може да смени
    var defaultPlan = root.querySelector('.sb-opt[data-group="plan"][data-value="p2"]');
    if (defaultPlan) { defaultPlan.classList.add('is-selected'); state.plan = 'p2'; }

    renderPackages();
    filterVarieties();
    render();
  }

  function boot() {
    document.querySelectorAll('.sub-builder').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
